import { ActivePhonesApi, ACTIVE_PHONES_ROUTES } from "@sms/shared/active-phones/active-phones.api";
import { ActivePhonesData } from "@sms/shared/active-phones/active-phones.interface";

import { apiFetch } from "../utils/api-fetch";
class ActivePhonesService implements ActivePhonesApi {
  getActivePhones(this: void): Promise<ActivePhonesData[]> {
    return apiFetch(ACTIVE_PHONES_ROUTES.getActivePhones());
  }
}

export const activePhonesService: ActivePhonesService = new ActivePhonesService();
